export const JOB_TITLES_LIST = [
  // Job Titles
  'Acting Sports & Wellbeing Team Leader TUI BLUE Sensatori',
  'Baby Club Host HOLIDAY VILLAGE',
  'Baby Club Host TUI BLUE Family Fun',
  'Baby Club Host TUI BLUE Sensatori',
  'Baby Club Host TUI KIDS CLUB',
  'Blue Guide Rep TUI BLUE Adults Only',
  'Blue Guide Rep TUI BLUE Core',
  'Blue Guide Rep TUI BLUE Family Fun',
  'Blue Guide Rep TUI BLUE Sensatori',
  'Blue Star Service & Activities Host',
  'Childcare Delivery Team Leader TUI KIDS CLUB',
  'Childcare Delivery Team Leader TUI BLUE Sensatori',
  'Childcare Delivery Team Leader TUI BLUE Family Fun',
  'Childcare Delivery Team Manager TUI BLUE Family Fun',
  'Childcare Supervisor TUI KIDS CLUB',
  'Childcare Supervisor TUI BLUE Sensatori',
  'Childcare Supervisor TUI BLUE Core',
  'Childcare Supervisor TUI BLUE Family Fun',
  'Childcare Supervisor HOLIDAY VILLAGE',
  'Entertainment & Activities Host TUI BLUE Core',
  'Entertainment & Activities Host TUI BLUE Family Fun',
  'Entertainment & Activities Host TUI BLUE Sensatori',
  'Entertainment & Activities Host TUI Suneo',
  'Entertainment & Activities Team Leader TUI BLUE Family Fun',
  'Entertainment & Activities Team Leader TUI Suneo',
  'Event & Activities Host TUI BLUE Adults Only',
  'Event & Activities Host Jumper TUI BLUE Adults Only',
  'Fitness & Leisure Jumper TUI BLUE Adults Only',
  'Fitness & Leisure Jumper TUI BLUE Sensatori',
  'Fitness & Leisure Jumper TUI BLUE Family Fun',
  'Fitness Instructor - Qualified TUI BLUE Adults Only',
  'Fitness Instructor - Qualified TUI BLUE Core',
  'Fitness Instructor - Qualified TUI BLUE Family Fun',
  'Fitness Instructor - Qualified TUI BLUE Sensatori',
  'Fitness Instructor - TUI Trained TUI BLUE Adults Only',
  'Fitness Instructor - TUI Trained TUI BLUE Core',
  'Fitness Instructor - TUI Trained TUI BLUE Family Fun',
  'Fitness Instructor - TUI Trained TUI BLUE Sensatori',
  'Football Coach HOLIDAY VILLAGE',
  'Holiday Village Academies Team Leader',
  'Holiday Village Experience Manager',
  'Kids Club Host - Qualified TUI BLUE Family Fun',
  'Kids Club Host - Qualified TUI BLUE Sensatori',
  'Kids Club Host - Qualified TUI KIDS CLUB',
  'Kids Club Host - TUI Trained TUI BLUE Family Fun',
  'Kids Club Host - TUI Trained TUI BLUE Sensatori',
  'Kids Club Host - TUI Trained TUI KIDS CLUB',
  'SENSATORI Expert',
  'Sports & Wellbeing Team Leader TUI BLUE Sensatori',
  'Sports Host TUI BLUE Family Fun',
  'Sports Host TUI BLUE Sensatori',
  'Swim Coach HOLIDAY VILLAGE',
  'Swim Coach TUI BLUE Family Fun',
  'TIME TO SMILE Service Host',
  'TUI BLUE Experience Manager TUI BLUE Adults Only',
  'TUI BLUE Experience Manager TUI BLUE Core',
  'TUI BLUE Experience Manager TUI BLUE Family Fun',
  'TUI BLUE Experience Manager TUI BLUE Sensatori',
  'Acting Airport Team Leader',
  'Acting Airport Team Manager',
  'Acting Service Support Team Leader',
  'Airport Rep',
  'Airport Senior Team Manager',
  'Airport Team Leader',
  'Airport Team Manager',
  'Destination Manager',
  'Excursion Rep',
  'Experiences Expert',
  'Hotel Rep',
  'Hotel Rep (L&M)',
  'Nile Imperial Blue Guide TUI BLUE Adults Only',
  'Operations Support Agent',
  'Operations Support Team Manager',
  'Quality Assurance Coordinator',
  'Resort Coordinator',
  'Senior Team Manager',
  'Service Delivery Manager',
  'Service Support Rep',
  'Service Support Rep (L&M)',
  'Service Support Team Leader',
  'Resort Team Leader',
  'Team Leader (L&M)',
  'Team Manager',
  'Team Manager (L&M)',
  'TXC Agent - 24x7',
  'Acting Crystal Ski Childcare Team Manager',
  'Acting Crystal Ski Senior Team Manager',
  'Acting Crystal Ski Team Leader',
  'Crystal Ski Childcare Rep',
  'Crystal Ski Childcare Supervisor',
  'Crystal Ski Destination Manager',
  'Crystal Ski Operations Agent',
  'Crystal Ski Operations Support Agent',
  'Crystal Ski Operations Support Team Leader',
  'Crystal Ski Operations Support Team Manager',
  'Crystal Ski Operations Team Leader',
  'Crystal Ski Operations Team Manager',
  'Crystal Ski Rep',
  'Crystal Ski Resort Accounts Controller',
  'Crystal Ski Senior Team Manager',
  'Crystal Ski Service Delivery Manager',
  'Crystal Ski Service Support Rep',
  'Crystal Ski Team Leader',
  'Crystal Ski Team Manager',
  'TUI Ski Rep',
  'CT 01 - TBA (TUI Blue Adults)',
  'CT 02 - TBFF (TUI Blue Family Fun)',
  'CT 03 - SENBTB (Sensatori by TUI Blue)',
  'CT 04 - TBFA (TUI Blue Core - For All)',
  'CT 05 - TKC (TUI Kids Club)',
  'CT 06 - TUI SUN (TUI Suneo)',
  'CT 07 - HV (Holiday Village)',
  'CT 08 - Shared Costs',
];
